import "./Footer.scss";

const Footer = () => {
  return (
    <footer className="footer">
      <p>&copy; 2025 Trip Card Explorer</p>
    </footer>
  );
};

export default Footer;
